import { createFileRoute } from "@tanstack/react-router";

import ManageLines from "@/components/ManageLines/ManageLines";

export const Route = createFileRoute("/gym/$venueUuid/settings/lines")({
  component: ManageLines,
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/settings",
      },
    };
  },
});
